<template>
    <div>
        <div><b-button class="customTextButton" v-on:click="toggleCustomText">{{buttonText}}</b-button></div>
        <div v-show="customTextOn">Pole na własny komunikat - 320 znaków max
            <b-form-textarea
            id="textarea"
            v-model="text"
            style="overflow:hidden"
            :state="text.length >= 10 && text.length <= 320"
            placeholder="Napisz komunikat 10 - 320 znaków"
            rows="2"
            max-rows="3"
            v-on:keyup="emitData"
            ></b-form-textarea>
        </div>
    </div>
</template>

<script>
export default {
    name: 'targetGroup',
    props: {
        buttonName: String,
        messageText: String,
    },
    methods: {
        toggleCustomText: function() {
            if(this.customTextOn === false){
                this.customTextOn = true;
                this.buttonText = this.messageText ? "Anuluj edycję komunikatu" : "Anuluj własny komunikat";
                this.$emit('sendCustomMessage', this.text);
                this.$emit('customTextOn', this.customTextOn);
            }   else {
                this.customTextOn = false;
                this.buttonText = this.buttonName;
                this.$emit('sendCustomMessage', this.textBackup);
                this.$emit('customTextOn', this.customTextOn);
                this.$emit('closeEdition');
            }
        },
        emitData: function(){
            this.$emit('sendCustomMessage', this.text);
        }
    },
    data: function(){
        return{
            customTextOn: false,
            text: this.messageText ? this.messageText : '',
            buttonText: this.buttonName,
            textBackup: this.messageText,
        }
    }
}
</script>

<style lang="scss" scoped>
    .customTextButton {
        width: 90%;
        background-color: green;
        border-radius: 10px;
        border: none;
        margin: 10px auto;
        &:hover{
            background-color: rgb(101, 168, 0);
        }
        &:focus{
            background-color: green;
            border: none;
            box-shadow: none;
        }
    }
    #textarea {
        overflow-y: none;
        color: red;
    }
</style>